import _ from 'lodash';
import Spinner from 'common/components/spinner/spinner';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { getUserActionSubscriptions } from './userActionSubscriptionsActions';
import { Typography } from '@material-ui/core';
import MaterialGrid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import PaymentIcon from '@material-ui/icons/Payment';
import { BUTTON_BACKGROUND_COLOR } from 'config/consts';
import UserActionSubscriptionsTable from './userActionSubscriptionsTable';

let UserActionSubscriptions = function ({
  history,
  getUserActionSubscriptions,
  userActionSubscriptions,
}) {
  const { actionId } = useParams();
  useEffect(() => {
    getUserActionSubscriptions(actionId);
  }, [actionId, getUserActionSubscriptions]);

  const [columns] = useState([
    { title: 'Atividade', field: 'action_subscription.description' },
    { title: 'Vigência', field: 'vigencia' },
    { title: 'Valor', field: 'priceFormatted' },
    { title: 'Status pagamento', field: 'paidFormatted' },
    { title: 'Recorrência', field: 'recurrenceFormatted' },
  ]);
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(userActionSubscriptions.list.content);
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, [userActionSubscriptions.list.content]);

  if (userActionSubscriptions.loading)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '92%', backgroundColor: 'transparent' }}
      >
        <Spinner />
      </div>
    );
  if (_.isEmpty(userActionSubscriptions.list.content)) {
    return (
      <section id="assinaturas-list" style={{ minHeight: '100vh' }}>
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: '92vh', backgroundColor: 'transparent' }}
        >
          <Typography variant="h6">Não há assinaturas</Typography>
        </div>
      </section>
    );
  }
  return (
    <section
      id="assinaturas-list"
      style={{ backgroundColor: 'transparent', minHeight: '100vh' }}
    >
      <Typography variant="h4">
        Minhas assinaturas
      </Typography>
      <div className="py-4">
        {data.some(it => !it.paid) && (
          <MaterialGrid
            container
            justifyContent="flex-end"
            alignItems="flex-end"
            xs={12}
          >
            <Button
              style={{
                margin: '12px 0px',
                backgroundColor: BUTTON_BACKGROUND_COLOR,
                textTransform: 'math-auto',
              }}
              variant="contained"
              color="primary"
              size="small"
              onClick={() => history.push('/homepage/cartao-assinatura')}
              startIcon={<PaymentIcon />}
            >
              Novo cartão
            </Button>
          </MaterialGrid>
        )}
        <UserActionSubscriptionsTable
          columns={columns}
          data={Object.groupBy(data, ({ actionId }) => actionId)}
        />
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    userActionSubscriptions: state.userActionSubscriptions,
    general: state.general,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getUserActionSubscriptions }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(UserActionSubscriptions);
